<template>

    <div id="ev-banner" class="carousel slide" data-ride="carousel">
 
  <!-- 指示符 -->
  <ul class="carousel-indicators">
    <li data-target="#ev-banner" data-slide-to="0" class="active"></li>
    <li data-target="#ev-banner" data-slide-to="1"></li> 
    <li data-target="#ev-banner" data-slide-to="2"></li>   
  </ul>
 
  <!-- 轮播图片 -->
  <div class="carousel-inner">
    <div class="carousel-item active">
      <img class="img-suit4" src="@/assets/images/banner1.png">
    </div>
    <div class="carousel-item">
      <img class="img-suit4" src="@/assets/images/banner2.png">
    </div>
    <div class="carousel-item">
      <img class="img-suit4" src="@/assets/images/banner3.png">
    </div>
  </div>
 
  <!-- 左右切换按钮 -->
  <a class="carousel-control-prev" href="#ev-banner" data-slide="prev">
    <span class="carousel-control-prev-icon"></span>
  </a>
  <a class="carousel-control-next" href="#ev-banner" data-slide="next">
    <span class="carousel-control-next-icon"></span>
  </a>
    
</div>
</template>

<script>
export default {
    
}
</script>